// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-toggler {
    border: none;
  }
  
  .navbar-toggler:hover {
    background-color: transparent;
    outline: none;
    border: none;
  }

  .navbar-toggler:focus {
    box-shadow: none;
  }
  .dropdown-basic {
    outline: none !important;
  }
  .dropdown-basic ::after{
    display: none !important;
  }


  .dropdown-submenu {
    position: relative;
  }
  
  .submenu-trigger:hover + .submenu,
  .submenu:hover {
    display: block;
  }
  
  .submenu {
    display: none;
    position: absolute;
    top: 0;
    left: 100%;
    min-width: 105px !important;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    z-index: 1000;
    padding: 5px 0;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  .submenu a {
    display: block;
    padding: 0.5rem 1rem;
    white-space: nowrap;
    color: black;
  }
  
  .submenu a:hover {
    background-color: #f8f9fa;
  }
  `, "",{"version":3,"sources":["webpack://./src/Component/PublicNavbar/PublicNavbar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,2BAA2B;IAC3B,uBAAuB;IACvB,qCAAqC;IACrC,aAAa;IACb,cAAc;IACd,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".navbar-toggler {\n    border: none;\n  }\n  \n  .navbar-toggler:hover {\n    background-color: transparent;\n    outline: none;\n    border: none;\n  }\n\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n  .dropdown-basic {\n    outline: none !important;\n  }\n  .dropdown-basic ::after{\n    display: none !important;\n  }\n\n\n  .dropdown-submenu {\n    position: relative;\n  }\n  \n  .submenu-trigger:hover + .submenu,\n  .submenu:hover {\n    display: block;\n  }\n  \n  .submenu {\n    display: none;\n    position: absolute;\n    top: 0;\n    left: 100%;\n    min-width: 105px !important;\n    background-color: white;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    padding: 5px 0;\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  }\n  \n  .submenu a {\n    display: block;\n    padding: 0.5rem 1rem;\n    white-space: nowrap;\n    color: black;\n  }\n  \n  .submenu a:hover {\n    background-color: #f8f9fa;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
